import dynamic from 'next/dynamic';
import Icon from '@utilities/icon';
import useModal from '@hooks/useModal';
import { Button } from '@com/_atoms/NewButton';
import { useGetProfile } from '@api/user/user.rq';
import { colorPallete } from '@configs/color-pallete';
import { onlineDoctorAlertText } from '@constant/ocs/doctor';

const LoggedForm = dynamic(() => import('./logged-form'));
const UnloggedForm = dynamic(() => import('./unlogged-form'));

type NotifyOnlineDoctorProps = {
  doctorId: number;
  specialityId: number;
};

const NotifyOnlineDoctor = ({
  doctorId,
  specialityId,
}: NotifyOnlineDoctorProps) => {
  const { data } = useGetProfile();
  const { addModal, removeLastModal } = useModal();

  const handleCloseBottomSheet = () => {
    removeLastModal();
  };

  const OnlineAlert = () => {
    const phoneNumber = data?.queryResult?.[0]?.phoneNumber;

    if (!phoneNumber) {
      return (
        <UnloggedForm
          doctorId={doctorId}
          specialityId={specialityId}
          onClose={handleCloseBottomSheet}
        />
      );
    }

    return (
      <LoggedForm
        doctorId={doctorId}
        phoneNumber={phoneNumber}
        specialityId={specialityId}
        onClose={handleCloseBottomSheet}
      />
    );
  };

  const handleOpenOnlineAlert = () => {
    addModal({
      modal: OnlineAlert,
    });
  };

  return (
    <div className="w-full shadow-fab rounded-lg bg-surface-primary p-4 flex flex-col gap-y-2 border">
      <span className="text-Label/xSmall text-content-secondary">
        {onlineDoctorAlertText?.description}
      </span>

      <Button
        size="medium"
        variant="secondary"
        className="text-Label/xSmall gap-x-1"
        icon={
          <Icon
            name="Bell"
            width={1}
            height={1}
            fill={colorPallete.content.primary}
          />
        }
        iconPosition="right"
        onClick={handleOpenOnlineAlert}
      >
        {onlineDoctorAlertText?.NotifyButton}
      </Button>
    </div>
  );
};

export default NotifyOnlineDoctor;
